import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "My ideas are shitty so I'm going on an internet diet",
  "description": "",
  "published": "2011-08-17T00:00:00.000Z",
  "redirect_from": ["/blog/my-ideas-are-shitty-so-im-going-on-an-internet-diet/swizec/2239"],
  "categories": "Online Communities, Social Networking, Twitter, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/300px-Internet_map_10243.jpg",
        "alt": "Visualization of the various routes through a ...",
        "title": "Visualization of the various routes through a ..."
      }}></img></p>
    <p>{`Lately we have seen a plague of Next Better Widget (tm) startups and bright minds all over the world solving frivolous problems that ultimately contribute nothing to the betterment of humanity as a whole. There are a bunch of people out there right now solving `}<a parentName="p" {...{
        "href": "https://twitter.com/#!/search?q=%23FirstWorldProblems"
      }}>{`#firstworldproblems`}</a>{`.`}</p>
    <p>{`A waste of talent!`}</p>
    <p>{`By being in the same boat I feel like I am betraying my ten year old self who had much bigger plans for me. His ideas on what sort of problems I should be solving was much worthier than what I have actually turned out to be working on.`}</p>
    <p>{`The main difference between my ten year old self and me is `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Internet",
        "title": "Internet"
      }}>{`the internet`}</a>{`.`}</p>
    <p>{`Back then I didn't have it, or rather what I did have was at a friend's house on a dial-up line if I asked really nicely. Sometimes even at the library!`}</p>
    <p>{`The ideas I had back then might not have been world changing, or they might have been, it's hard to say, but the ideas I have right now certainly don't seem as grand.`}</p>
    <p>{`This leads me to believe that the ideas we have reflect the kind of world we live in.`}</p>
    <p>{`Spending a lot of time on the internet makes us see the problems that exist there. And they look like big important problems. But really, when you take a step or two back, they're pretty lame ideas that are almost a waste of time to have anyone working on.`}</p>
    <p>{`Thus I have decided to go offline for a month, starting tomorrow.`}</p>
    <p>{`But because going completely dark would devastate my life, probably make it stop dead (how unlike an addict eh?), I am going to set some ground rules that won't ban the internet completely; just make it a bit ... less.`}</p>
    <ul>
      <li parentName="ul">{`as a coding reference, the internet is ok`}</li>
      <li parentName="ul">{`wikipedia is alright, but keep it down`}</li>
      <li parentName="ul">{`I will continue writing my blog`}</li>
      <li parentName="ul">{`using `}<a parentName="li" {...{
          "href": "http://750words.com"
        }}>{`750words.com`}</a>{` every morning is good`}</li>
      <li parentName="ul">{`there will be at most an hour every evening of HN/fb/twitter/email`}</li>
      <li parentName="ul">{`if something absolutely spectacular happens you are allowed to tweet, no reading outside the hour!`}</li>
      <li parentName="ul">{`checking in to foursquare is questionable ... perhaps ban it?`}</li>
      <li parentName="ul">{`skype is ok`}</li>
    </ul>
    <p>{`To mak sure my slight addiction doesn't get in the way I will likely use an `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Hosts_%28file%29",
        "title": "Hosts (file)"
      }}>{`/etc/hosts`}</a>{` hack and make sure facebook.com and similar don't load outside the allotted hour a day and I will turn off push notifications on everything on my phone. But I `}<em parentName="p">{`will`}</em>{` try to rough it at first.`}</p>
    <p>{`Right now I have no idea how this experiment will pan out. Most likely I'll keep finding some sort of excuse for not doing it or I will break down in tears and cry in a fetal position in the corner. I might even start reading proper books again! That would be awesome.`}</p>
    <p>{`Hopefully by the end of the 30 days I will have a less polluted perspective in the world.`}</p>
    <p>{`Wish me luck!`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://aldorf.wordpress.com/2011/08/11/dont-fear-the-internet-dot-com/"
        }}>{`Dont Fear The Internet Dot Com`}</a>{` (aldorf.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://dilbert.com/blog/entry/the_economic_value_of_a_business_startup/"
        }}>{`The Economic Value of a Business Startup`}</a>{` (dilbert.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://kellysutton.tumblr.com/post/8930005518/if-our-ideas-seem-smaller-nowadays-its-not"
        }}>{`"If our ideas seem smaller nowadays, it's not because we are dumber than our forebears but because we..."`}</a>{` (kellysutton.tumblr.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://news.slashdot.org/story/11/08/16/0142226/The-Post-Idea-World"
        }}>{`The Post-Idea World`}</a>{` (news.slashdot.org)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=38f92c98-fc80-48ae-bfcd-99be2ac93f19",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      